var map = {
	"./counter-consumption_gas rlm.svg": 6692,
	"./counter-consumption_gas.svg": 2260,
	"./counter-consumption_strom rlm.svg": 2513,
	"./counter-consumption_strom.svg": 3036,
	"./counter-consumption_type.svg": 4789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8901;